export default "__VITE_ASSET__Na6xngrW__"